<template lang="pug">
  .coupon-item
    v-card.elevation-0.border-bottom.pa-3(style="border-radius:0px")
      v-row
        v-col.shrink
          v-icon(size="12" color="info500" v-if="coupon.discount_percentage") mdi-circle
          v-icon(size="12" color="warning500" v-if="coupon.discount_amount") mdi-circle
          v-icon(size="12" color="success500" v-if="coupon.free_shipping") mdi-circle
        v-col.pt-4
          div.p2.mb-1.textColorHint--text
            div(v-if="coupon.discount_percentage") {{ $t('discount') }}: {{ coupon.discount_percentage }}%
            div(v-if="coupon.discount_amount") {{ $t('discount') }}: {{ coupon.discount_amount | displayPrice }}
            div(v-if="coupon.free_shipping") {{ $t('free_shipping') }}
          div.s1.textColorDefault--text(v-text="coupon.code")
          div.s1.textColorDefault--text {{ $t('minimum_order_amount') }}: {{ coupon.minimum_order_amount | displayPrice }}
          div.d-flex
            .p2 {{ $t('total_redeemed') }}: {{ coupon.total_redeemed }}
            v-spacer
            .p2(v-if="coupon.inventory_enabled") {{ $t('remaining') }}: {{ coupon.inventory_qty }}

        v-col.shrink.pr-1(v-if="member.role === 'Admin'")
          v-menu(bottom :offset-x='false' :offset-y='true')
            template(v-slot:activator='{ on }')
              v-btn.elevation-0.pa-0.ma-auto.mt-3(text color="transparent" min-width="auto"  :ripple="false" x-small light v-on='on')
                eva-icon(name="more-vertical" :fill="$vuetify.theme.themes[$theme].primary500" height="25" width="25" )
            v-list.pa-0
              v-list-item.border-bottom(
                @click="clickEdit"
              )
                v-list-item-content
                  v-list-item-title.s2.basic800--text {{ $t('edit_coupon') }}
              v-list-item.border-bottom(
                @click="clickDelete"
              )
                v-list-item-content
                  v-list-item-title.s2.basic800--text() {{ $t('delete_coupon') }}

    .modals
      add-coupon(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :parentCoupon.sync="coupon" :company="company")
      y-dialog(v-model='openDeleteDialog', max-width='290' persistent)
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_coupon') }}
          v-card-text.p2.primary500--text.px-4
            | {{ $t('delete_coupon_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white' text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn(color='danger500' depressed dark @click='startDelete' :loading="isLoading")
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex'
import AddCoupon from '@/components/offers/dialogs/coupons/AddCoupon.vue'
export default {
  name: 'CouponItem',
  props: ['parentCoupon'],
  components: { AddCoupon },
  data: () => ({
    showAddProductDialog: false,
    openDeleteDialog: false,
    isLoading: false
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    coupon: {
      get() {
        return this.parentCoupon
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickEdit () {
      this.showAddProductDialog = true
    },
    clickDelete () {
      this.openDeleteDialog = true
    },
    startDelete() {
      this.isLoading = true
      this.axios.delete(`/promo/coupons/${this.coupon.id}/`)
        .then(() => {
          this.$emit('deleted', this.coupon)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.border-bottom{
    border-bottom: 1px solid var(--v-basic300);
    border-radius: 0 !important;
}
.count-layout {
  position: absolute;
  right: 10px;
  top: 6px;
}
.product-title {
  font-size: 16px;
  font-weight: bold;
  height: 2.8em; 
  line-height: 1.4em; 
  overflow: hidden;
}
.product-description {
  font-size: 12px;
  height: 3.3em; 
  text-overflow: ellipsis; 
  line-height: 1.1em; 
  white-space: pre-wrap;
  overflow: hidden;
}
.product-price {
  font-size: 16px;
  font-weight: bold;
}
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
</style>

<i18n>
{
  "en": {
    "discount": "Discount",
    "free_shipping": "Free Shipping",
    "minimum_order_amount": "Minimum order amount",
    "total_redeemed": "Total redeemed",
    "remaining": "Remaining",
    "edit_coupon": "Edit Coupon",
    "delete_coupon": "Delete Coupon",
    "delete_coupon_confirmation": "Are you sure you want to delete this item? This item will be deleted permanently."
  },
  "id": {
    "discount": "Diskon",
    "free_shipping": "Pengiriman gratis",
    "minimum_order_amount": "Jumlah Pesanan Minimum",
    "total_redeemed": "Total yang ditukarkan",
    "remaining": "Tersisa",
    "edit_coupon": "Edit Kupon",
    "delete_coupon": "Hapus Kupon",
    "delete_coupon_confirmation": "Anda yakin ingin menghapus item ini? Item ini akan dihapus secara permanen."
  }
}
</i18n>
